import React from 'react';

import Button from '../ui/Button';

const CustomerNavigationOverlay = ({
  onBack,
  onClose,
  onViewAR,
  showBackButton = false,
  showCloseButton = true,
  showARButton = false,
  position = 'top',
  className = ''
}) => {
  const positionClasses = {
    top: 'top-3 left-3 right-3 sm:top-4 sm:left-4 sm:right-4',
    bottom: 'bottom-4 left-4 right-4',
    'top-right': 'top-4 right-4'
  };

  return (
    <div
      className={`customer-nav-overlay fixed ${positionClasses?.[position]} z-ar pointer-events-none ${className}`}
    >
      <div className="flex items-center justify-between gap-2 pointer-events-auto">
        <div className="flex items-center gap-2 sm:gap-3">
          {showBackButton && onBack && (
            <button
              onClick={onBack}
              aria-label="Go back"
              className="customer-nav-back inline-flex items-center justify-center w-11 h-11 min-w-[44px] min-h-[44px] rounded-xl bg-white/95 hover:bg-white text-foreground shadow-warm-md hover:shadow-warm-lg touch-target transition-smooth active:scale-95 border border-border/30 flex-shrink-0"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="m12 19-7-7 7-7"/>
                <path d="M19 12H5"/>
              </svg>
              <span className="sr-only">Back</span>
            </button>
          )}
        </div>

        <div className="flex items-center gap-2 sm:gap-3 ml-auto">
          {showARButton && onViewAR && (
            <Button
              variant="default"
              onClick={onViewAR}
              className="customer-nav-ar bg-accent hover:bg-accent/90 shadow-warm-md hover:shadow-warm-lg touch-target transition-smooth active:scale-96"
              iconName="Scan"
              iconPosition="left"
              iconSize={20}
            >
              View in AR
            </Button>
          )}

          {showCloseButton && onClose && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="customer-nav-close bg-card/95 hover:bg-card shadow-warm-md hover:shadow-warm-lg touch-target transition-smooth active:scale-96"
              iconName="X"
              iconSize={20}
              aria-label="Close"
            >
              <span className="sr-only">Close</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerNavigationOverlay;